"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const RepeatPageFieldWrapper = props => {
    return (react_1.default.createElement("div", { style: { flexDirection: 'column' } },
        react_1.default.createElement("div", { style: {
                margin: 1,
                display: 'flex',
                flexDirection: 'column',
            } }, props.children)));
};
exports.default = RepeatPageFieldWrapper;
//# sourceMappingURL=RepeatPageFieldWrapper.js.map